<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      <b-button class="button is-primary" @click="handleAddAnnouncement">
        Anunt nou
      </b-button>
    </hero-bar>
    <section class="section is-main-section">
      <card-component
        class="has-table has-mobile-sort-spaced"
        title="Inregistrari"
        icon="file-multiple"
      >
        <announcements-table
          :announcements="announcements"
          :isLoading="isLoading"
          :total="totalCount"
          :current-page="currentPage"
          @handleDeleteAnnouncement="handleDeleteAnnouncement"
          @page-change="onPageChange"
        />
      </card-component>
      <hr />
    </section>
  </div>
</template>

<script>
import Announcements from "@/services/announcements.service";
import { notify } from "@/helpers/notify";
import AnnouncementsTable from "@/components/announcements/announcements-table";
import CardComponent from "@/components/CardComponent";
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
const _ = require("lodash");
export default {
  name: "Announcements",
  components: {
    HeroBar,
    TitleBar,
    CardComponent,
    AnnouncementsTable,
  },
  data() {
    return {
      isLoading: true,
      announcements: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 20,
    };
  },
  async created() {
    this.loadAnnouncements();
  },
  methods: {
    loadAnnouncements() {
      this.isLoading = true;
      this.getAllAnnouncements()
        .then((data) => {
          if (Array.isArray(data)) {
            this.announcements = data;
            this.totalCount = data.length;
          } else {
            this.announcements = data.items;
            this.totalCount = data.totalCount;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async getAllAnnouncements() {
      const { getAllAnnouncements } = Announcements;
      const response = await getAllAnnouncements(this.currentPage, this.pageSize);
      return response.data;
    },
    async onPageChange(page) {
      this.currentPage = page;
      this.loadAnnouncements();
    },
    async handleAddAnnouncement() {
      this.$router.push({
        path: "/announcements/add",
      });
    },
    async handleDeleteAnnouncement(id) {
      try {
        const { handleDeleteAnnouncement } = Announcements;
        const response = await handleDeleteAnnouncement(id);
        const { data, status } = response;
        if (status == "200") {
          const index = this.announcements.findIndex((prop) => prop.id === id);
          this.announcements.splice(index, 1);
          notify.success(this, "Inregistrarea a fost stearsa.");
        } else {
          notify.error(this, "Eroare la stergerea inregistrarii.");
        }
      } catch (error) {
        notify.error(this);
      }
    },
  },
  computed: {
    titleStack() {
      return ["Anunturi"];
    },
    heroRouterLinkTo() {
      return { name: "/announcements/add" };
    },
  },
};
</script>
